module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-1920-21f9c6edb8798eff93595b846a926096.jpg";